import BasicSelect from "components/BasicInputs/BasicSelect";
import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { apiGetProjects } from "api/projectApi";
import { useDispatch, useSelector } from "react-redux";
import { appSetModal } from "store/actions/appAction";
import BasicTextInput from "../BasicInputs/BasicTextInput";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import { utils } from "@taak/react-modern-calendar-datepicker";

export interface SpecificationsFormProps {
    data?: Specifications;
    onChange: (specs: SpecificationsFormProps["data"]) => void;
}

export default function SpecificationsForm(props: SpecificationsFormProps) {
    const { data, onChange } = props;
    const dispatch = useDispatch();
    const [specs, setSpecs] = useState(data);
    const { token } = useSelector((state: any) => state).businessReducer.business;

    useEffect(() => onChange(specs), [specs]);
    useEffect(() => setSpecs(data), [data]);

    return (
        <>
            <div className="px-6 py-3 bg-white rounded-s-xl mb-1">
                <h6 style={{ margin: 0 }}>{"مشخصات"}</h6>
            </div>
            <div className="p-6 bg-white mb-6">
                <div className="flex justify-between items-end flex-wrap gap-10">
                    <div className="flex flex-row gap-3 w-full md:w-auto md:min-w-[500px]">
                        <BasicSelect
                            label="سال*"
                            options={Array.from({ length: 5 }, (v, i) => {
                                return { value: utils("fa").getToday().year - i, id: utils("fa").getToday().year - i, label: utils("fa").getToday().year - i }
                            })}
                            defaultValue={specs?.year}
                            onChange={(val) => {
                                
                                setSpecs((specs) => ({ ...specs, year: val }))
                            }}
                            withSearch
                        // @ts-ignore
                        //refreshList={() => dispatch(apiGetProjects(token))}
                        />
                        <BasicSelect
                            label="ماه*"
                            defaultValue={specs?.month}
                            options={[
                                { id: 1, value: 1,label: 'فروردین' },
                                { id: 2, value: 2,label: 'اردیبهشت' },
                                { id: 3, value: 3,label: 'خرداد' },
                                { id: 4, value: 4,label: 'تیر' },
                                { id: 5, value: 5,label: 'مرداد' },
                                { id: 6, value: 6,label: 'شهریور' },
                                { id: 7, value: 7,label: 'مهر' },
                                { id: 8, value: 8,label: 'آبان' },
                                { id: 9, value: 9,label: 'آذر' },
                                { id: 10, value: 10,label: 'دی' },
                                { id: 11, value: 11,label: 'بهمن' },
                                { id: 12, value: 12,label: 'اسفند' },

                            ]}
                            onChange={(val) => setSpecs((specs) => ({ ...specs, month: val }))}
                            withSearch
                        // @ts-ignore
                        //refreshList={() => dispatch(apiGetProjects(token))}
                        />
                        <BasicTextInput
                            label="شرح*"
                            onChange={(val) => val && setSpecs((specs: any) => ({ ...specs, description: val }))}
                            fullWidth
                        />
                    </div>
                    <div className="flex justify-end items-end flex-wrap gap-8 gap-y-12 w-full md:w-auto">
                        <div className="w-full md:w-32 flex flex-col gap-3">
                            <BasicDateInput
                                label="تاریخ*"
                                onChange={(dates) => dates && setSpecs((specs) => ({ ...specs, date: dates[0] }))}
                            />
                        </div>
                        <div className="flex gap-2 h-10 w-full md:w-[316px] items-end">
                            <div className="flex flex-col gap-3 w-full md:w-[268px]">
                                <div>
                                    <span style={{ color: "#33383D" }}>{"پروژه"}</span>
                                    <span style={{ color: "#666666" }}>{" (اختیاری)"}</span>
                                </div>
                                <BasicSelect
                                    options={(data && data.projects) || []}
                                    onChange={(val) => setSpecs((specs) => ({ ...specs, project: val }))}
                                    withSearch
                                    withRefresh
                                    // @ts-ignore
                                    refreshList={() => dispatch(apiGetProjects(token))}
                                />
                            </div>
                            <Button
                                variant="outlined"
                                color="primary"
                                style={{ minWidth: 40, minHeight: 40, padding: 0, borderRadius: 6 }}
                                onClick={() => {
                                    const addModal = {
                                        component: "project",
                                        title: "افزودن پروژه",
                                        closeButton: true,
                                        onFinish: (token: any) => apiGetProjects(token),
                                    };
                                    dispatch(appSetModal({ ...addModal }));
                                }}
                            >
                                <Add style={{ width: 20 }} />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
